import { render } from "./page-purchase.vue?vue&type=template&id=4147abe8&lang=html"
import script from "./page-purchase.vue?vue&type=script&lang=js"
export * from "./page-purchase.vue?vue&type=script&lang=js"
script.render = render

export default script